// extracted by mini-css-extract-plugin
export default {"wrapper":"box-message_wrapper__1fuwN","message":"box-message_message__rHRnf","subMessage":"box-message_subMessage__tZqs-"};